import { render } from "./Docs.vue?vue&type=template&id=6bec7e90"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__